import type { ApiResponse } from "~~/server/utils/apiResponse";
import type { APIProduct } from "~~/shared/types/product";
import type { SmartFetchOptions } from "~/utils/smart-fetch";
import type { ActiveFilter } from "~/components/page/categories/filters/main.vue";

export interface ProductCategoryFilters {
    filter?: ActiveFilter;
    sort?: unknown;
    include?: unknown;
}

export const productService = {
    async getProducts(options?: SmartFetchOptions) {
        return await smartFetch<APIPaginate<APIProduct>>("/v1/products", {
            ...options,
            baseTarget: "local",
        });
    },

    async getProductDetail(identifier: string | number) {
        return await smartFetch<ApiResponse<APIProduct>>(`/v1/products/${identifier}`, {
            baseTarget: "local",
            credentials: "include",
            params: {
                include: "category,prices,gallery,attributes,variants,comments,user_price,faq,price",
            },
        });
    },

    async getTrends() {
        return await smartFetch<ApiResponse<APIProduct[]>>("/v1/products/trends", {
            baseTarget: "local",
        });
    },

    async getLatest(limit?: number) {
        return await smartFetch<ApiResponse<APIProduct[]>>("/v1/products/latest", {
            baseTarget: "local",
            params: { per_page: limit },
        });
    },

    async getCategoryProducts(slug: string, filters?: ProductCategoryFilters) {
        return await smartFetch<ApiResponse<{ category: APICategory; products: APIProduct[] }>>(
            `/v1/categories/${encodeURIComponent(slug)}/products`,
            {
                baseTarget: "local",
                params: filters,
            }
        );
    },
};
